// extracted by mini-css-extract-plugin
export default {"wrapper":"mAZF70It--MarkdownWrapper_wrapper__g8p+g"};